const initialState = {
  uploadError: {},
  loading: false,
  cocData: {},
};

const cocs = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'COC_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'COC_CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        cocData: payload.cocData,
        uploadError: '',
      };
    case 'COC_CREATE_FAILURE':
      return {
        ...state,
        cocData: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default cocs;



// WEBPACK FOOTER //
// ./client/app/reducers/cocs.js